import React from "react";
import { useTranslation } from "react-i18next";
import {
  useRetrieveCurrentPlanzone,
  useRetrieveProjectPortfolios,
} from "@planzone/view-models";
import { Identifiable, ProjectPortfolio as P } from "@planzone/dto";

import { ProjectPortfolioIcon } from "@common/projectPortfolioIcon";
import { filterSearch } from "../utils";
import { Section } from "../section";
import { ScrollPane } from "../scrollPane";
import { Loader } from "../loader";
import { Props } from "./types";
import { Portfolio } from "./portfolios";
import styles from "./styles.scss";

function ProjectPortfolios({ search, filter, setFilter, isOpen }: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    portfolios,
    retrieveProjectPortfolios,
  } = useRetrieveProjectPortfolios();
  const selectProject = (portfolio: Identifiable<P>) =>
    setFilter(filter ? [...filter, portfolio] : [portfolio]);
  const unSelectProject = ({ uuid }: Identifiable<P>) =>
    filter && setFilter(filter.filter((portfolio) => portfolio.uuid !== uuid));

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveProjectPortfolios(planzone);
  }, []);

  return (
    <Section
      header={
        <div className={styles.header}>
          <ProjectPortfolioIcon className={styles.icon} />
          <p className={styles.title}>
            {t("common.filterMenu.projectPortfolios.title")}
          </p>
        </div>
      }
      list={
        <ScrollPane>
          <div className={styles.list}>
            {!isRequestPending ? (
              filterSearch(portfolios, search).map((portfolio) => (
                <Portfolio
                  key={portfolio.uuid}
                  portfolio={portfolio}
                  isSelected={
                    !!filter &&
                    !!filter.find(({ uuid }) => uuid === portfolio.uuid)
                  }
                  select={() => selectProject(portfolio)}
                  unSelect={() => unSelectProject(portfolio)}
                />
              ))
            ) : (
              <Loader />
            )}
          </div>
        </ScrollPane>
      }
      isOpen={isOpen}
    />
  );
}

export { ProjectPortfolios };
